<template>
  <div>
    <div
      class="p-grid"
      v-if="
        $ability.can('manage', 'App') &&
        $ability.can('read', 'Home') &&
        !vetCustomer
      "
    >
      <div class="p-col-12" style="width: 100%">
        <AccountStats />
      </div>
      <div class="p-col-12 p-md-5">
        <BovineByFarmChart ref="bovineByFarmChart" />
      </div>
      <div class="p-col-12 p-md-7">
        <BovineByFarmLotChart ref="bovineByFarmLotChart" />
      </div>
      <div class="p-col-12 p-md-5">
        <div class="p-grid">
          <div class="p-col-12">
            <HelpLinks />
          </div>
          <div class="p-col-12">
            <VersionNotes />
          </div>
        </div>
      </div>
      <div class="p-col-12 p-md-7">
        <BovineByRegistrationChart />
      </div>
    </div>
    <span>
      <AccountWarningOverdue
        v-if="user?.account?.statusId === 2"
        v-model:visible="showAccountWarning"
        :account="user.account"
      />
      <AccountWarningTrial
        v-if="user?.account?.statusId === 6"
        v-model:visible="showAccountWarning"
        :account="user.account"
      />
      <WhatsNew></WhatsNew>
    </span>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import AccountWarningTrial from '../../components/AccountWarningTrial';
import AccountWarningOverdue from '../../components/AccountWarningOverdue';
import BovineByFarmChart from './components/BovineByFarmChart';
import BovineByFarmLotChart from './components/BovineByFarmLotChart';
import BovineByRegistrationChart from './components/BovineByRegistrationChart';
import AccountStats from './components/AccountStats';
import HelpLinks from './components/HelpLinks';
import VersionNotes from './components/VersionNotes';
import { FarmApi } from '../../services/api';
import WhatsNew from './components/WhatsNew.vue';

export default {
  name: 'Home',
  components: {
    AccountWarningTrial,
    AccountWarningOverdue,
    BovineByFarmChart,
    BovineByFarmLotChart,
    BovineByRegistrationChart,
    AccountStats,
    HelpLinks,
    VersionNotes,
    WhatsNew,
  },
  computed: {
    ...mapFields('app', ['showAccountWarning', 'user', 'vetCustomer']),
  },
  data() {
    return {
      farms: [],
    };
  },
  async created() {
    if (!this.$ability.can('read', 'Farm')) {
      return;
    }
    const { results: farms } = await FarmApi.fetch({
      order: 'asc',
      orderField: 'id',
    });
    this.farms = farms;
    this.$refs.bovineByFarmChart.setFarms(farms);
    this.$refs.bovineByFarmLotChart.setFarms(farms);
  },
};
</script>

<style>
</style>
